import { SvgIcon } from "../../common/SvgIcon";
import { Container, Logos, LogoWrapper } from "./styles";

const Partners = () => {
  return (
    <Container>
      <h6>Our Partners</h6>
      <Logos>
        <LogoWrapper>
          <SvgIcon src="partner-berlin.svg" width="200px" height="auto" />
        </LogoWrapper>
        <LogoWrapper>
          <SvgIcon src="partner-avant-now.svg" width="100px" height="auto" />
        </LogoWrapper>
        <LogoWrapper>
          <SvgIcon src="partner-eu.svg" width="250px" height="auto" />
        </LogoWrapper>
      </Logos>
    </Container>
  );
};

export default Partners;
